import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import axios from 'axios';
import { X, Download } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function MusicQRModal({ isOpen, onClose }) {
  const [qrCode, setQrCode] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isOpen) return;

    const fetchQRCode = async () => {
      try {
        const response = await axios.get(`${API}/music/qr-code`, { withCredentials: true });
        setQrCode(response.data.qr_code);
        setLoading(false);
      } catch (error) {
        console.error('[MUSIC] Failed to fetch QR code:', error);
        setLoading(false);
      }
    };

    fetchQRCode();
  }, [isOpen]);

  const handleDownload = () => {
    const svg = document.getElementById('music-qr-code');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'dimakas-music-qr.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/90 flex items-center justify-center z-[99999]"
      onClick={onClose}
    >
      <div 
        className="bg-zinc-900 rounded-lg p-8 max-w-md w-full mx-4 border border-zinc-800"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-light tracking-wider text-white">🎵 Music QR Code</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-zinc-800 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-zinc-400" />
          </button>
        </div>

        {loading ? (
          <div className="text-center py-12 text-zinc-500">Loading...</div>
        ) : (
          <>
            {/* QR Code */}
            <div className="bg-white p-6 rounded-lg mb-6 flex justify-center">
              <QRCodeSVG
                id="music-qr-code"
                value={qrCode}
                size={256}
                level="H"
                includeMargin={true}
              />
            </div>

            {/* Code Text */}
            <div className="mb-6">
              <label className="block text-sm text-zinc-400 mb-2">QR Code Value:</label>
              <div className="p-3 bg-zinc-800 rounded-lg border border-zinc-700">
                <code className="text-white text-sm break-all">{qrCode}</code>
              </div>
            </div>

            {/* Instructions */}
            <div className="mb-6 p-4 bg-zinc-800/50 rounded-lg border border-zinc-700">
              <h3 className="text-white font-medium mb-2">Οδηγίες:</h3>
              <ul className="text-sm text-zinc-400 space-y-1 list-disc list-inside">
                <li>Δείξε αυτό το QR στους πελάτες</li>
                <li>Σκανάρουν με το 🎵 button στο menu</li>
                <li>Παίρνουν 1 ώρα access για μουσική</li>
                <li>Μπορούν να προσθέσουν YouTube URLs</li>
              </ul>
            </div>

            {/* Download Button */}
            <button
              onClick={handleDownload}
              className="w-full py-3 bg-white text-black font-medium rounded-lg hover:bg-zinc-200 transition-colors flex items-center justify-center gap-2"
            >
              <Download className="w-5 h-5" />
              Download QR Code
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default MusicQRModal;
